import React,{useState,useEffect} from 'react';
import Box from '../../components/Box';
import { NavLink } from 'react-router-dom';
import styles from './styles.module.css';

const DemoGallery = props => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        window.addEventListener('resize', updateWindowWidth);
        return () => {
            window.removeEventListener('resize', updateWindowWidth);
        }
    })

    const updateWindowWidth = () => {
        setWidth(window.innerWidth)
    }
    
    return (
        <div className={[styles.container]}>
            <div className={width>700&& styles.row}>
                <Box
                imgSrc={require('../../assets/white.jpg')}
                label={'Bar and Stack charts'}
                onClick={()=>{window.location.pathname="/gallerybar"}}
                />
                <video
                muted
                autoPlay
                loop
                style={{height:440,width:360}}
                onClick={()=>{window.location.pathname="/gallerybar"}}
                src={require('../../assets/bars.mov')}/>
            </div>
            <div className={width>700&& styles.row}>
                {width>700&&<div className={styles.columned}>
                <img
                    src={require('../../assets/animatedDataLine.gif')}
                    style={{width:300}}
                    onClick={()=>{window.location.pathname="/galleryline"}}
                    alt=''/>
                    <img
                    src={require('../../assets/areas.png')}
                    style={{height:180}}
                    onClick={()=>{window.location.pathname="/galleryline"}}
                    alt=''/>
                    <video
                    muted
                    autoPlay
                    loop
                    style={{height:300,width:280}}
                    onClick={()=>{window.location.pathname="/galleryline"}}
                    src={require('../../assets/lining.mov')}/>
                </div>}
                <Box
                imgSrc={require('../../assets/blank.jpg')}
                label={'Line and Area charts'}
                onClick={()=>{window.location.pathname="/galleryline"}}
                />
                {width<=700&&<div className={styles.columned}>
                    <img
                    src={require('../../assets/areas.png')}
                    style={{height:200,width:340}}
                    onClick={()=>{window.location.pathname="/galleryline"}}
                    alt=''/>
                    <video
                    muted
                    autoPlay
                    loop
                    style={{height:400,width:320}}
                    onClick={()=>{window.location.pathname="/galleryline"}}
                    src={require('../../assets/line.mov')}/>
                </div>}
            </div>
            <div className={width>700&& styles.row} style={{marginBottom:160}}>
                <Box
                imgSrc={require('../../assets/empty.jpg')}
                label={'Pie and Donut charts'}
                onClick={()=>{window.location.pathname="/gallerypie"}}/>
                <div className={styles.columned}>
                    <img
                        src={require('../../assets/pies.png')}
                        style={{height:180,width:320}}
                        onClick={()=>{window.location.pathname="/gallerypie"}}
                        alt=''/>
                    <div className={styles.bodyText} style={{marginTop:80}}>
                        Making awesome charts with <a href='https://www.npmjs.com/package/react-native-gifted-charts' style={{fontWeight:'bold',fontSize:15, color:'#1A3360'}}>react-native-gifted-charts</a> is a piece of cake.
                    </div>
                    <div className={styles.bodyText} style={{marginTop:20}}>
                        Start your first with just 2 lines of code!
                    </div>
                    <NavLink
                    className={styles.linkText}
                    to='/barchart'>
                        Proceed to docs
                    </NavLink>
                </div>
            </div>
        </div>
    )
}

export default DemoGallery;